module.exports = __webpack_public_path__ + "img/payment-systems-disabled.ad54bb29.png";